import { Skeleton } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

import { ShouldRender } from '../../../shared/basic/ShouldRender';

const BookCardSkeleton = () => {
  const screens = useBreakpoint();
  return (
    <div className='w-full rounded-md cursor-pointer flex flex-col transition duration-300 '>
      <div className='h-full text-fadedWhite flex flex-col'>
        <div className='flex flex-col md:flex-row gap-y-4 items-center h-full gap-x-6'>
          <div className='flex gap-x-3 w-full md:w-fit'>
            <div className='flex justify-center min-w-[93px] md:min-w-[152px]'>
              <div className='lg:w-full flex justify-center h-full'>
                <Skeleton.Image className='w-[93px] md:w-[150px] h-[136px] md:h-[220px] rounded-md md:rounded-lg' />
              </div>
            </div>
            <ShouldRender check={!screens.md}>
              <div className='flex flex-col gap-y-2'>
                <Skeleton.Input className='w-3/4 h-6' active />
                <Skeleton paragraph={{ rows: 1 }} active />
              </div>
            </ShouldRender>
          </div>
          <div className='h-full w-full'>
            <div className='flex flex-col justify-between h-full w-full gap-y-2'>
              <ShouldRender check={screens.md}>
                <Skeleton.Input className='w-3/4 h-6' active />
                <Skeleton paragraph={{ rows: 2 }} active />
              </ShouldRender>
              <div className='flex gap-y-2 gap-x-2 md:gap-x-3 w-full justify-center'>
                <Skeleton.Button className='w-full h-10' active />
                <Skeleton.Button className='w-full h-10' active />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookCardSkeleton;
